import clsx from "clsx";
import styles from "./index.module.scss";
import { useLocation } from "react-router-dom";

const DashboardTabs = ({ activeTab = "dashboard", onTabChange, tabs }) => {
  const location = useLocation();
  const programTitle = location.state?.programTitle;
  return (
    <div className={styles.tabsWrapper}>
      <h2 className={styles.logo}>{programTitle ? programTitle : "HDB/MSD 2025-26"}</h2>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={clsx(styles.tab, {
              [styles.active]: activeTab === tab.key,
            })}
            onClick={() => onTabChange?.(tab.key)}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DashboardTabs;